export const processSubstatusData = (data) => {
  return {
    ...data,
    updated_at_date: new Date(data.updatedAt),
  };
};
